import axios from "axios";
import { API_URL } from "../../constants";
import _ from "lodash";

export default {
  getAllOrders: (page, pageSize, searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axios.get(`${API_URL.ORDERS}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        page: page,
        pageSize: pageSize,
        ...filteredParams,
      },
    });
  },

  orderExport: (searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axios.get(`${API_URL.ORDER_EXPORT}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        ...filteredParams,
      },
    });
  },
};
